export default __webpack_public_path__ + "static/media/Stalker's Gloves of Charred Earth.ccce4522.jpg";